//TODO: Refactor if other account asks for this feature
import SettingsDataAccess from '../services/settingsDataAccess';
const settingsDataAccess = new SettingsDataAccess();

async function getAccountDefaultFromDateOffset() {
    function isInteger(str) {
        const num = parseFloat(str);
        return !isNaN(num) && Number.isInteger(num);
    }

    let result = await settingsDataAccess.getAccountSettingsBySettingsName("DefaultSnChartFromDateOffset");
    if (result && result.data && result.data.Id > 0 && isInteger(result.data.SettingValue)) {
        return result.data.SettingValue;
    }
    else {
        return '30';
    }
}
export async function getDateOffset(account) {
    if (account === "823")
        return 60;

    return await getAccountDefaultFromDateOffset();
}




// WEBPACK FOOTER //
// ./src/services/accountSettings.js